import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../hooks/use-http";
import { Chart } from "react-google-charts";

const GanttChart = () => {

  const [activityTimeline, setActivityTimeline] = useState([]);
  const [plotList, setPlotList] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const [monthNames, setmonthNames] = useState(["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
]);

   
  const { isLoading: eload, error: er, sendRequest: getactivityTimeline } = useHttp();


  useEffect(() => {
    getactivityTimeline(
      {
        url: `/api/get_fieldActivity_detail/?orgId=${localStorage.getItem("orgId")}`,        
      },
      (data) => {
        console.log("plot data", data);

        var dataSort=data.sort((a, b) => {
          a = a.startDate.split('/');
          b = b.startDate.split('/');
          return a[2] - b[2] || a[1] - b[1] || a[0] - b[0];
          }) 

        setActivityTimeline(dataSort)

      
        
        if(dataSort.length)
        {
          getMonthList (dataSort)
        }
         
      }
    );
  }, [getactivityTimeline]);

  const getMonthList = (monthDataList) => {

    var tempmonthDataList= monthDataList.map(record=>({...record,monthName:""}))

     

  var newMonthData=[];

   var k=0;
       monthDataList.forEach((item) => {
        var aDate = item.startDate.split('/');
        var monthName= monthNames[parseInt( aDate[1])-1]+" "+ aDate[2];

        var uniqueData=newMonthData.filter((itm=>(itm.monthName==monthName)))
         
        tempmonthDataList[k].monthName=monthName;
        if(uniqueData&&uniqueData.length==0)
        {
        newMonthData = newMonthData.concat({
          monthName: monthName,
          monthId: aDate[1],
          yearId: aDate[2],

        });
      }
      k++;

       });
       setMonthList(newMonthData);
       
       
       var plotlst = [...new Set(monthDataList.map((q) => q.plotName))];
   

       var plotData=[];

       plotlst.forEach((item) => {
        var plotMonthData=[];
             
        newMonthData.forEach((itm) => {


         
        
          var selectedActivity=tempmonthDataList.filter((items)=>(items.plotName==item) &&
          (items.monthName==itm.monthName))
     
          var colColor1="skyblue";
          var colColor2="skyblue";
          var colColor3="skyblue";
          var colColor4="skyblue";
          console.log(" plot Name", item);
          console.log(" itm.monthName", itm.monthName);
          console.log(" selectedActivity", selectedActivity);

          if(selectedActivity&&selectedActivity.length>0)
          {
            var totalActivityct=selectedActivity.length;
            var Activitypendinglst=selectedActivity.filter((items)=>(items.activityStatus=="pending"))
            var totalPendingActivityct=Activitypendinglst&&Activitypendinglst.length;
             
            if(totalActivityct==totalPendingActivityct)
            {
                colColor1="orange";
                colColor2="orange";
                colColor3="orange";
                colColor4="orange";
            }
            else
            { 

              var ActivityCompletedlst=selectedActivity.filter((items)=>(items.activityStatus=="completed"))
              var totalcompletedActivityct=ActivityCompletedlst&&ActivityCompletedlst.length;

             
              if(totalActivityct==totalcompletedActivityct)
              {
                colColor1="green";
                colColor2="green";
                colColor3="green";
                colColor4="green";
              } else
              { 
                colColor1="orange";
                colColor2="orange";
                colColor3="orange";
                colColor4="orange";

                 var completedcount= parseInt( totalcompletedActivityct /totalActivityct)
                  if(completedcount>8)
                  {
                    colColor1="green";
                    colColor2="green";
                    colColor3="orange";
                  } else if(completedcount>5)
                  {
                    colColor1="green";
                    colColor2="green";
                  } else  if(completedcount>2)
                  {
                    colColor1="green";
                  }
                   
                   
              }

            }
          }

          console.log("colColor1", colColor1);
          console.log("colColor2", colColor2);
          console.log("colColor3", colColor3);
          console.log("colColor4  ", colColor4);

          plotMonthData = plotMonthData.concat({ 
                  colMonth:itm,
                  colColor1: colColor1,  
                  colColor2: colColor2,     
                  colColor3: colColor3,    
                  colColor4: colColor4,         
                });
                
                
        });

        

        plotData = plotData.concat({
            plotName:item,
            monthData:plotMonthData,

          });

 

      });

      console.log(" plotData", plotData);
       setPlotList(plotData)

      

  }
 

  return (
    

  


<div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
            
              <label className="card-title mx-2 my-3"> &nbsp; &nbsp;
              Activity Timeline </label>
              <hr />
            </div>
            
            
          </div>

        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              {/* <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button> */}
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive">
                    <tr>
    <th style={{
position:"sticky",left:"0px",color:"white",backgroundColor:"#343a40"

    }}>Plot Name</th>


{monthList &&monthList.map((itm, i) => {
                            return (
                              <th style={{
                                 color:"white",backgroundColor:"#343a40"
                                
                                    }}>
                                {itm.monthName}
                                </th>
                               
                            );
                          })}

     
  </tr>

  {plotList &&plotList.map((itm, i) => {
                            return (

                              <tr key={i}>
                              <td style={{
position:"sticky",left:"0px",color:"white",backgroundColor:"#343a40"

    }}>
                                {itm.plotName}
                               </td>

                               {itm.monthData &&itm.monthData.map((item, i) => {
                            return (
                              // <th style={{backgroundColor:item.colColor}}>
                              <td style={{margin:"0px",padding:"0px"}}>
                               
     <div style={{backgroundColor:item.colColor1,float:"left",padding:"0px",margin:"0px",width:"25%",height:"60px"}}>&nbsp;</div>
      <div style={{backgroundColor:item.colColor2,float:"left",padding:"0px",margin:"0px",width:"25%",height:"60px"}}>&nbsp;</div>
      <div style={{backgroundColor:item.colColor3,float:"left",padding:"0px",margin:"0px",width:"25%",height:"60px"}}>&nbsp;</div>
      <div style={{backgroundColor:item.colColor4,float:"left",padding:"0px",margin:"0px",width:"25%",height:"60px"}}>&nbsp;</div>
  
      </td> 
                                  
                            );
                          })}


                                </tr>
                               
                            );
                          })}

                          
  {/* <tr>
    <td style={{
position:"sticky",left:"0px",backgroundColor:"grey"

    }}>11:40   </td>
    <td>Maria Anders</td>
    <td>Alfreds Futterkiste</td> 
    <td>Maria Anders</td>
    <td>Alfreds Futterkiste</td>
    <td>Maria Anders</td>
    
  </tr>
  <tr>
    <td style={{
position:"sticky",left:"0px",backgroundColor:"grey"

    }}>11:40   </td>
    <td style={{margin:"0px",padding:"0px"}}>
      <div style={{backgroundColor:"green",float:"left",width:"25%",height:"60px"}}>&nbsp;</div>
      <div style={{backgroundColor:"green",float:"left",width:"25%",height:"60px"}}>&nbsp;</div>
      <div style={{backgroundColor:"green",float:"left",width:"25%",height:"60px"}}>&nbsp;</div>
      <div style={{backgroundColor:"green",float:"left",width:"25%",height:"60px"}}>&nbsp;</div>
    </td>
    <td style={{margin:"0px",padding:"0px"}}>

    <div style={{backgroundColor:"green",float:"left",width:"25%",height:"60px"}}>&nbsp;</div>
    <div style={{backgroundColor:"green",float:"left",width:"25%",height:"60px"}}>&nbsp;</div>
    <div style={{backgroundColor:"green",float:"left",width:"25%",height:"60px"}}>&nbsp;</div>
    <div style={{backgroundColor:"yellow",float:"left",width:"25%",height:"60px"}}>&nbsp;</div>
    </td>
    <td></td>
    <td></td>
    <td></td>
 
  </tr>
  <tr>
    <td style={{
position:"sticky",left:"0px",backgroundColor:"grey"

    }}>11:40   </td>
    <td>Maria Anders</td>
    <td>Alfreds Futterkiste</td>
    <td>Maria Anders</td>
    <td>Alfreds Futterkiste</td>
    <td>Maria Anders</td>
    
  </tr>
  <tr>
   <td style={{
position:"sticky",left:"0px",backgroundColor:"grey"

    }}>11:40   </td>
    <td>Maria Anders</td>
    <td>Alfreds Futterkiste</td>
    <td>Maria Anders</td>
    <td>Alfreds Futterkiste</td>
    <td>Maria Anders</td>
   
  </tr> */}
   
 
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    {/* <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
  );
};

export default GanttChart;
